import React from 'react'
import styles from '../AllProjFolder/AllProj.module.css'
import elite from '../../Images/elite1.jpeg'
import elite1 from '../../Images/elite01.jpeg'
import pharmfac1 from '../../Images/pharma-factory1.jpg'
import pharmfac2 from '../../Images/pharma-factory5.jpg'
import pharmfac3 from '../../Images/pharma-factory3.jpg'
import pharmfac4 from '../../Images/pharma-factory4.jpg'
import pharmfac5 from '../../Images/pharma-factory2.jpg'
import projects1 from '../../Images/projects1.png'
import cid1 from '../../Images/cid1.jpg'
import escap1 from '../../Images/escap1.jpg'
import osra from '../../Images/osra1.jpeg'
import alunile from '../../Images/sadatfac.jpg'
import amricana from '../../Images/amricana.jpg'
import nilex from '../../Images/nilex1.jpg'
import dabaa from '../../Images/dabaa.jpg'
import najar from '../../Images/najar1.png'
import ifcg1 from '../../Images/ifcg1.jpg'
import kenana1 from '../../Images/kenana5.jpg'
import sheraton from '../../Images/sheraton.jpg'
import goldens from '../../Images/goldens.jpg'
import ksa from '../../Images/ksa.jpg'
import nasser from '../../Images/nasser.jpg'
import nasserOffice from '../../Images/nasserOffice.jpg'
import foodstore from '../../Images/food.jpg'
import interlock1 from '../../Images/interlock1.jpg'
import centralKitchen1 from '../../Images/centralKitchen1.jpg'
import serviceBuilding1 from '../../Images/serviceBuilding1.jpg'
import workshop2 from '../../Images/workshop2.jpg'
import storage1 from '../../Images/storage1.jpg'
import interior1 from '../../Images/interior1.jpg'
import interior2 from '../../Images/interior2.jpg'
import interior3 from '../../Images/interior3.jpg'
import interior4 from '../../Images/interior4.jpg'
import interior5 from '../../Images/interior5.jpg'
import interior6 from '../../Images/interior6.jpg'
import interior7 from '../../Images/interior7.jpg'
import interior8 from '../../Images/interior8.jpg'
import interior9 from '../../Images/interior9.jpg'
import interior10 from '../../Images/interior10.jpg'
import interior11 from '../../Images/interior11.jpg'
import interior12 from '../../Images/interior12.jpg'
import interior13 from '../../Images/interior13.jpg'
import interior14 from '../../Images/interior14.jpg'
import interior15 from '../../Images/interior15.jpg'
import interior16 from '../../Images/interior16.jpg'
import interior17 from '../../Images/interior17.jpg'
import interior18 from '../../Images/interior18.jpg'
import interior19 from '../../Images/interior19.jpg'
import interior20 from '../../Images/interior20.jpg'
import interior21 from '../../Images/interior21.jpg'
import interior22 from '../../Images/interior22.jpg'
import interior23 from '../../Images/interior23.jpg'
import interior24 from '../../Images/interior24.jpg'
import interior25 from '../../Images/interior25.jpg'
import interior26 from '../../Images/interior26.jpg'
import interior27 from '../../Images/interior27.jpg'
import interior28 from '../../Images/interior28.jpg'
import interior29 from '../../Images/interior29.jpg'
import interior30 from '../../Images/interior16.jpg'
import interior31 from '../../Images/interior31.jpg'
import interior32 from '../../Images/interior32.jpg'
import interior33 from '../../Images/interior33.jpg'
import interior34 from '../../Images/interior34.jpg'
import interior35 from '../../Images/interior35.jpg'
import interior36 from '../../Images/interior35.jpg'
import em1 from '../../Images/em1.jpg'
import hospital2 from '../../Images/hospital2.png'
import hospital3 from '../../Images/hospital3.png'
import hospital4 from '../../Images/hospital4.jpg'
import azema from '../../Images/azema1.jpg'
import hospital7 from '../../Images/hospital7.png'
import portsaid from '../../Images/portsaid.jpg'
import sa from '../../Images/sa1.jpg'
import dental from '../../Images/dental1.jpg'
import smart from '../../Images/smart1.jpg'
import hospital from '../../Images/hhospital1 (1).jpg'
import godness from '../../Images/godness1.jpg'
import eng from '../../Images/eng1.jpg'
import dar from '../../Images/dar1.jpg'
import kayan from '../../Images/kayan1.jpg'
import domiat from '../../Images/d1.jpeg'
import home from '../../Images/bayt elwatan.jpeg'
import clinic1 from '../../Images/clinic1.jpeg'
import Footer from '../../FooterFolder/Footer';
import ayesh from '../../Images/ayesh4.jpeg'
import go1 from '../../Images/go9.jpeg'
import { Link } from 'react-router-dom'
import AOS from "aos";
import 'aos/dist/aos.css'
import { useEffect } from 'react'


export default function AllProj() {

  useEffect(() => {
    AOS.init({duration: 1500})
  
  }, [])

  return (

    <>
       <section className='container-fluid my-5 py-5'>
        
        {/* categories */}

       <div className="container-fluid my-4">
              <div className="row">
                <div className="col-md-12 ">
                <ul className={`${styles.subNavBgColorAndFram} nav pt-3 d-flex justify-content-center align-items-center`}>
           
                  <li className="nav-item ">
                  <Link to="/UrbanProjects" className={`${styles.linkPro}`}> 
                   <p className='text-center mx-4'>Urban Planning  </p>
                  </Link> 
                  </li>

                  <li className="nav-item ">
                  <Link to="/pharma" className={`${styles.linkPro}`}> 
                   <p className='text-center mx-4 '>Pharmaceutical Factories</p>
                   </Link>  
                  </li>

                  <li className="nav-item ">
                  <Link to="/proj5Edu" className={`${styles.linkPro}`}> 
         
            <p className='text-center mx-4'>Medical And Educational Buildings</p>
            </Link> 
                  </li>

                  <li className="nav-item ">
                  <Link to="/proj1Industerial" className={`${styles.linkPro}`}> 
           
            <p className='text-center mx-4'>Industrial projects</p>
            </Link> 
                  </li>

                  <li className="nav-item ">
                  <Link to="/proj5Banks" className={`${styles.linkPro}`}> 
          
            <p className='text-center mx-4'>Banks</p>
            </Link> 
                  </li>

                  <li className="nav-item ">
                  <Link to="/ra" className={`${styles.linkPro}`}> 
           
            <p className='text-center mx-4 '>Residential & Administrative Buildings </p>
             </Link> 
                  </li>

                  <li className="nav-item ">
                  <Link to="/proj5RB" className={`${styles.linkPro}`}> 
            
            <p className='text-center mx-4'>Office & Commercial Buildings </p>
            </Link> 
                  </li>

                  <li className="nav-item ">
                  <Link to="/interior" className={`${styles.linkPro}`}> 
        
            <p className='text-center mx-4'>Interior Projects</p>
            </Link>  
                  </li>

                  <li className="nav-item ">
                  <Link to="/proj5MB" className={`${styles.linkPro}`}> 
          
            <p className='text-center mx-4'>Hotels And Clubs</p>
            </Link> 
                  </li>

                  <li className="nav-item ">
                  <Link to="/travcoGroup" className={`${styles.linkPro}`}> 
            <p className='text-center mx-4'>Tarvco group buildings </p>
            </Link> 
                   
                  </li>



                </ul>
              </div>
              </div>
       </div>

        {/* All projects */}

<div className="row">

  <div className="col-md-3 text-center" data-aos='fade-up'> 
      <Link to="/ayesh" className={`${styles.linkPro}`}> 
    <img src={ayesh} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3'> Ayesh Hospital in 10th of ramadan  </p>
     </Link> 
  </div>
    <div className="col-md-3 text-center" data-aos='fade-up'> 
      <Link to="/elite" className={`${styles.linkPro}`}> 
    <img src={elite} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3'> Rabie al – takyeef factory , 6th of October city  </p>
     </Link> 
  </div>
  <div className="col-md-3 text-center" data-aos='fade-up'> 
      <Link to="/elitee" className={`${styles.linkPro}`}> 
    <img src={elite1} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3'> Elite Artists Residence   </p>
     </Link> 
  </div>
        <div className="col-md-3 text-center" data-aos='fade-up'> 
      <Link to="/domiat" className={`${styles.linkPro}`}> 
    <img src={domiat} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3'> New Damietta Eye Medical Center </p>
     </Link> 
  </div>

    <div className="col-md-3 text-center" data-aos='fade-up'> 
      <Link to="/baytElwatan" className={`${styles.linkPro}`}> 
    <img src={home} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3'> Bayt Al Watan Building </p>
     </Link> 
  </div>

      <div className="col-md-3 text-center" data-aos='fade-up'> 
      <Link to="/HealthInsuranceClinics" className={`${styles.linkPro}`}> 
    <img src={clinic1} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3'> Health Insurance Clinics </p>
     </Link> 
  </div>

      <div className="col-md-3 text-center" data-aos='fade-up'> 
      <Link to="/goplast" className={`${styles.linkPro}`}> 
    <img src={go1} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3'> Gomplast Factory </p>
     </Link> 
  </div> 

<div className="col-md-3 text-center" data-aos='fade-up'> 
      <Link to="/alunile" className={`${styles.linkPro}`}> 
    <img src={alunile} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3'> Alunile Factory  </p>
     </Link> 
  </div>

  <div className="col-md-3 text-center" data-aos='fade-up'> 
      <Link to="/najar" className={`${styles.linkPro}`}> 
    <img src={najar} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3'> Najar Factory  </p>
     </Link> 
  </div>
  <div className="col-md-3 text-center " data-aos='fade-up'>
      <Link to="/dabaa" className={`${styles.linkPro}`}> 
    <img src={dabaa} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3'>El Dabaa Cold Store </p> 
     </Link> 
  </div>

  <div className="col-md-3 text-center" data-aos='fade-up'>      
    <Link to="/nilex" className={`${styles.linkPro}`}>    
    <img src={nilex} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3'>Nilex Frozen Factory </p>
    </Link> 
  </div>

  <div className="col-md-3 text-center" data-aos='fade-up'>
 <Link to="/americana" className={`${styles.linkPro}`}> 
 <img src={amricana} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
 <p className='text-center fw-bold mt-3'> Americana for food-6th October city </p>
 </Link>  
  </div>
  <div className="col-md-3 text-center" data-aos='fade-up'>
 <Link to="/ifcg" className={`${styles.linkPro}`}> 
 <img src={ifcg1} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
 <p className='text-center fw-bold mt-3'> International Food Consumable Goods (IFCG) </p>
 </Link>  
  </div>

  <div className="col-md-3 text-center" data-aos='fade-up'>
 <Link to="/kenana" className={`${styles.linkPro}`}> 
 <img src={kenana1} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
 <p className='text-center fw-bold mt-3'> Kenana factory </p>
 </Link>  
  </div>
 
    

        <div className="col-md-3 my-3 text-center" data-aos='fade-up'>
        <Link to="/hekma" className={`${styles.linkPro}`}> 
            <img src={pharmfac1} alt="achegy" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3 '>Hekma Pharma-6th October city</p>
            </Link> 
          </div>
          <div className="col-md-3 my-3 text-center" data-aos='fade-up'>
          <Link to="/riva" className={`${styles.linkPro}`}>  
            <img src={pharmfac4} alt="achegy" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3 '> RIVA Pharma–Nasir City </p>
            </Link> 
          </div>
          <div className="col-md-3 my-3 text-center" data-aos='fade-up'>
          <Link to="/eg" className={`${styles.linkPro}`}> 
            <img src={projects1} alt="achegy" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3 '> EG GEL for medicines - 6th October city </p>
            </Link> 
          </div>
          <div className="col-md-3 my-3 text-center" data-aos='fade-up'>
          <Link to="/bio" className={`${styles.linkPro}`}> 
            <img src={projects1} alt="achegy" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3 '> Biological products and medicines factory - 6th octover city </p>
            </Link> 
          </div>
          <div className="col-md-3 my-3 text-center" data-aos='fade-up'>
          <Link to="/cid" className={`${styles.linkPro}`}> 
            <img src={cid1} alt="achegy" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3 '> cid Pharmaceutical , haram city  </p>
            </Link> 
          </div>
          <div className="col-md-3 my-3 text-center" data-aos='fade-up'>
          <Link to="/escap" className={`${styles.linkPro}`}> 
            <img src={escap1} alt="achegy" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3 '> Ecap  vacsera , agouza , giza </p>
            </Link> 
          </div>
                  <div className="col-md-3 my-3 text-center" data-aos='fade-up'>
           
         <Link to="/nerhado" className={`${styles.linkPro}`}> 
         <img src={pharmfac2} alt="achegy" className={`${styles.imgSizeProj}`}/>
         <p className='text-center fw-bold mt-3 '>Nerhado for medicines-6th October city</p>
         </Link>  
          </div>
          <div className="col-md-3 my-3 text-center" data-aos='fade-up'>
              <Link to="/andalos" className={`${styles.linkPro}`}> 
            <img src={pharmfac5} alt="achegy" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3 '>AL-Andalus for medicines–6th October city </p>
             </Link> 
          </div>
          <div className="col-md-3 my-3 text-center" data-aos='fade-up'>
          <Link to="/solvida" className={`${styles.linkPro}`}> 
            <img src={pharmfac3} alt="achegy" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3'>SOLVIDA Pharma-10th Ramadan</p>
            </Link> 
          </div>




        <div className="col-md-3 text-center" data-aos='fade-up'>
           
         <Link to="/sheraton" className={`${styles.linkPro}`}> 
         <img src={sheraton} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
         <p className='text-center fw-bold mt-3'>Sheraton Building</p>
         </Link>  
          </div>
          <div className="col-md-3 text-center" data-aos='fade-up'>
              <Link to="/golden" className={`${styles.linkPro}`}> 
            <img src={goldens} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3'>Golden Pyramids </p>
             </Link> 
          </div>
          <div className="col-md-3 text-center" data-aos='fade-up'>
             <Link to="/ksa" className={`${styles.linkPro}`}> 
            <img src={ksa} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3'>AL HIJRAH RESIDENTIAL & COMMERCIAL</p>
             </Link> 
         
          </div>
          <div className="col-md-3 text-center" data-aos='fade-up'>
         <Link to="/nasser" className={`${styles.linkPro}`}> 
         <img src={nasser} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
         <p className='text-center fw-bold mt-3'>Nasser Rashed Residential Tower, Qatar </p>
         </Link>  
          </div>
          <div className="col-md-3 text-center" data-aos='fade-up'>
         <Link to="/nasserOffice" className={`${styles.linkPro}`}> 
         <img src={nasserOffice} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
         <p className='text-center fw-bold mt-3'>Nasser Rashed Office Tower, Qatar </p>
         </Link>  
          </div>

     
    
     
     

      <div className="col-md-3 text-center" data-aos='fade-up'> 
      <Link to="/foodstore" className={`${styles.linkPro}`}> 
    <img src={foodstore} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3'>Food Store </p>
     </Link> 
       </div>   

       <div className="col-md-3 text-center" data-aos='fade-up'>    
 <Link to="/interlock" className={`${styles.linkPro}`}> 
 <img src={interlock1} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
 <p className='text-center fw-bold mt-3'>Interlock industries</p>
 </Link>  
      </div>

  <div className="col-md-3 text-center" data-aos='fade-up'>    
 <Link to="/centralkitchen" className={`${styles.linkPro}`}> 
 <img src={centralKitchen1} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
 <p className='text-center fw-bold mt-3'>Central Kitchen</p>
 </Link>  
  </div>
  
  <div className="col-md-3 text-center" data-aos='fade-up'>    
 <Link to="/servicebuilding" className={`${styles.linkPro}`}> 
 <img src={serviceBuilding1} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
 <p className='text-center fw-bold mt-3'>Service building</p>
 </Link>  
  </div>

  <div className="col-md-3 text-center" data-aos='fade-up'>    
 <Link to="/workshop" className={`${styles.linkPro}`}> 
 <img src={workshop2} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
 <p className='text-center fw-bold mt-3'>Work Shop</p>
 </Link>  
  </div>

  <div className="col-md-3 text-center" data-aos='fade-up'>    
 <Link to="/storage" className={`${styles.linkPro}`}> 
 <img src={storage1} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
 <p className='text-center fw-bold mt-3'>Storage</p>
 </Link>  
  </div>

    

     


<div className="col-md-3 text-center" data-aos='fade-up'>
    
    <Link to="/sahrgt" className={`${styles.linkPro}`}> 
    <img src={sa} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3 '>Sahrgt Hospital </p>
    </Link>  
    </div>
    <div className="col-md-3 text-center" data-aos='fade-up'>
    
    <Link to="/dental" className={`${styles.linkPro}`}> 
    <img src={dental} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3 '> Dental Medical Center</p>
    </Link>  
    </div>
    <div className="col-md-3 text-center" data-aos='fade-up'>
    
    <Link to="/smartCare" className={`${styles.linkPro}`}> 
    <img src={smart} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3 '>   Smart Care Hospital in Mokattam</p>
    </Link>  
    </div>
    <div className="col-md-3 text-center" data-aos='fade-up'>
    
    <Link to="/Hospital5" className={`${styles.linkPro}`}> 
    <img src={azema} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3 '>Al Azema Hospital </p>
    </Link>  
    </div>
    <div className="col-md-3 text-center" data-aos='fade-up'>
    
    <Link to="/Hospital4" className={`${styles.linkPro}`}> 
    <img src={hospital4} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3 '>Hana Medical Center</p>
    </Link>  
    </div>
    <div className="col-md-3 text-center" data-aos='fade-up'>
    
    <Link to="/muscular" className={`${styles.linkPro}`}> 
    <img src={hospital} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3 '> Muscular Dystrophy Hospital</p>
    </Link>  
    </div>
    <div className="col-md-3 text-center" data-aos='fade-up'>
    
  <Link to="/Hospital2" className={`${styles.linkPro}`}> 
  <img src={hospital2} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
  <p className='text-center fw-bold mt-3 '>ABHA Hospital , Abha , KSA</p>
  </Link>  
    </div>
    <div className="col-md-3 text-center" data-aos='fade-up'>
    
  <Link to="/Hospital3" className={`${styles.linkPro}`}> 
  <img src={hospital3} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
  <p className='text-center fw-bold mt-3 '>NRC Hospital , Jeddah , KSA</p>
  </Link>  
    </div>
    <div className="col-md-3 text-center" data-aos='fade-up'>
    
    <Link to="/godnessHospital" className={`${styles.linkPro}`}> 
    <img src={godness} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3 '>Bawbtak lelkher Hospital</p>
    </Link>  
    </div>
    <div className="col-md-3 text-center" data-aos='fade-up'>
    
    <Link to="/darElShifaHospital" className={`${styles.linkPro}`}> 
    <img src={dar} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3 '>  Dar Al Shifa Hospital</p>
    </Link>  
    </div>
    <div className="col-md-3 text-center" data-aos='fade-up'>
    
    <Link to="/kayan" className={`${styles.linkPro}`}> 
    <img src={kayan} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3 '>  Kayan Hospital</p>
    </Link>  
    </div>

  <div className="col-md-3 text-center" data-aos='fade-up'>
    
  <Link to="/Hospital6" className={`${styles.linkPro}`}> 
  <img src={osra} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
  <p className='text-center fw-bold mt-3 '>Al Osra Hospital </p>
  </Link>  
  </div>
  <div className="col-md-3 text-center" data-aos='fade-up'>
    
    <Link to="/Hospital7" className={`${styles.linkPro}`}> 
    <img src={hospital7} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3 '>October International Hospital </p>
    </Link>  
    </div>
    <div className="col-md-3 text-center" data-aos='fade-up'>
    
    <Link to="/Hospital1" className={`${styles.linkPro}`}> 
    <img src={em1} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3 '>Al Shorouk Hospital</p>
    </Link>  
    </div>
    <div className="col-md-3 text-center" data-aos='fade-up'>
    
    <Link to="/portsaid" className={`${styles.linkPro}`}> 
    <img src={portsaid} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3 '>Port said School</p>
    </Link>  
    </div>
    <div className="col-md-3 text-center" data-aos='fade-up'>
    
    <Link to="/eng" className={`${styles.linkPro}`}> 
    <img src={eng} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
    <p className='text-center fw-bold mt-3 '>Engineers Restaurant </p>
    </Link>  
    </div>





   
      

      

<div className="col-md-3 text-center p-2" >
 <img src={interior16} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior17} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior18} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior19} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior20} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior21} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior22} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior23} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior24} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior25} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior26} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior27} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior28} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior29} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior30} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior31} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior32} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior33} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior34} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior35} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2" >
 <img src={interior36} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>

<div className="col-md-3 text-center p-2" >
 <img src={interior1} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2">
 <img src={interior2} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2">
 <img src={interior3} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2">
 <img src={interior4} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2">
 <img src={interior5} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2">
 <img src={interior6} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2">
 <img src={interior7} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>

</div>
<div className="col-md-3 text-center p-2">
 <img src={interior8} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
</div>
<div className="col-md-3 text-center p-2">
 <img src={interior9} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
</div>
<div className="col-md-3 text-center p-2">
 <img src={interior10} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
</div>
<div className="col-md-3 text-center p-2">
 <img src={interior11} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
</div>
<div className="col-md-3 text-center p-2">
 <img src={interior12} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
</div>
<div className="col-md-3 text-center p-2">
 <img src={interior13} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
</div>
<div className="col-md-3 text-center p-2">
 <img src={interior14} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
</div>
<div className="col-md-3 text-center p-2">
 <img src={interior15} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
</div>

</div>
     

       </section>

    <Footer />
    
    </>
   
  )
}
  {/* <div className="row">

       <div className="col-md-3 my-3 text-center" data-aos='fade-up'>
          <Link to="/UrbanProjects" className={`${styles.linkPro}`}> 
            <img src={projects10} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3'>Urban Planning  </p>
            </Link> 
          </div>

        <div className="col-md-3 my-3 text-center" data-aos='fade-up'>
           
         <Link to="/pharma" className={`${styles.linkPro}`}> 
         <img src={projects1} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
         <p className='text-center fw-bold mt-3 '>Pharmaceutical Factories</p>
         </Link>  
          </div>
         
          <div className="col-md-4 my-3 text-center" data-aos='fade-up'>
          <Link to="/proj5Edu" className={`${styles.linkPro}`}> 
            <img src={projects7} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3'>Medical And Educational Buildings</p>
            </Link> 
          </div>
          <div className="col-md-4 my-3 text-center" data-aos='fade-up'>
          <Link to="/proj1Industerial" className={`${styles.linkPro}`}> 
            <img src={projects3} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3'>Industrial projects</p>
            </Link> 
          </div>
       
          <div className="col-md-4 my-3 text-center" data-aos='fade-up'>
          <Link to="/proj5Banks" className={`${styles.linkPro}`}> 
            <img src={projects6} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3'>Banks</p>
            </Link> 
          </div>
          <div className="col-md-4 my-3 text-center" data-aos='fade-up'>
              <Link to="/ra" className={`${styles.linkPro}`}> 
            <img src={projects8} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3 '>Residential & Administrative Buildings </p>
             </Link> 
          </div>
        
          <div className="col-md-4 my-3 text-center" data-aos='fade-up'>
          <Link to="/proj5RB" className={`${styles.linkPro}`}> 
            <img src={projects2} alt="architecture consulting house ACH" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3'>Office & Commercial Buildings </p>
            </Link> 
          </div>
       
          <div className="col-md-4 my-3 text-center" data-aos='fade-up'>
          <Link to="/interior" className={`${styles.linkPro}`}> 
            <img src={projects9} alt="achegy" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3'>Interior Projects</p>
            </Link> 
          </div>

          <div className="col-md-4 my-3 text-center" data-aos='fade-up'>
          <Link to="/proj5MB" className={`${styles.linkPro}`}> 
            <img src={projects4} alt="achegy" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3'>Hotels And Clubs</p>
            </Link> 
          </div>

          <div className="col-md-12 my-3 text-center" data-aos='fade-up'>
          <Link to="/travcoGroup" className={`${styles.linkPro}`}> 
            <img src={interlock1} alt="achegy" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3'>Tarvco group buildings </p>
            </Link> 
          </div>
         
        </div> */}